import pick from 'lodash/pick';

/**
 * Return selected values of an object as a single string.
 *
 * @param obj Object to convert
 * @param keys Keys to include
 */
const getValuesAsString = <T extends object>(obj: T, keys: Array<keyof T>) =>
    Object.values(pick(obj, keys))
        .map((v) => `${v}`.trim().toLowerCase())
        .filter((v) => !!v)
        .join(' ');

export default getValuesAsString;
